import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SideBar from "../components/SideBar";
import "../styles/MemberDetails.css";
import { FaRegUserCircle } from "react-icons/fa";
import { MdOutlineLocationOn, MdUpdate, MdOutlineAssignmentInd } from "react-icons/md";

function CustomerDetails() {
  
  const location = useLocation();
  const customer = location.state?.customer;
  const navigate = useNavigate();

  if (!customer) {
    return <p style={{ padding: "30px" }}>No customer data available.</p>;
  }

  // Safely access properties with fallbacks for real API data
  const firstName = customer.first_name || customer.firstName || 'N/A';
  const surname = customer.last_name || customer.surname || 'N/A';
  const email = customer.email || 'N/A';
  const mobile = customer.phone_number || customer.mobile || 'N/A';
  
  // Safely access address data with fallbacks
  const address = customer.address || {};
  const addressLine1 = customer.address_line1 || address.line1 || 'N/A';
  const addressLine2 = customer.address_line2 || address.line2 || 'N/A';
  const addressLine3 = customer.address_line3 || address.line3 || 'N/A';
  const city = customer.city || address.city || 'N/A';
  const postcode = customer.postcode || address.postcode || 'N/A';
  
  // Handle region/county - check multiple possible properties
  const region = customer.region || 
                customer.county || 
                (customer.countries && customer.countries[0]?.region) || 
                address.county || 
                'N/A';
  
  // Handle country - check multiple possible properties
  const country = (customer.countries && customer.countries[0]?.name) || 
                  address.country || customer.country ||
                  'N/A';

  // Handle status and notes
  const status = customer.current_status || customer.status || 'N/A';
  const notes = customer.status_note || customer.notes || 'No notes available';

  const referrer_name = customer.referrer_name || 'N/A';

  const goToWallet = () => {
      navigate('/customer-wallet-details', {state: {customer}})
  }

  const goToWalletSummary = () => {
      navigate('/customer-wallet-summary', {state: {customer}})
  }

  const goToRequestHistory = () => {
      navigate('/customer-cash-request-history', {state: {customer}})
  }

  const goToEdit = () => {
    navigate("/edit-customer-profile", {state: {customer}})
  }

  return (
    <div className="member-details-layout">
      <SideBar />

      <div className="member-details-main">

        {/* Header */}
        <div className="details-header">
          <h2>Customer Details</h2>
          <p>You can edit your details to update your profile</p>
        </div>

        {/* Breadcrumb */}
        <div className="breadcrumb">
          <Link to="/dashboard" className="breadcrumb-link">Home</Link>
          <span className="breadcrumb-separator">{">"}</span>
          <Link to="/manage-customer" className="breadcrumb-link">Manage Customer</Link>
          <span className="breadcrumb-separator">{">"}</span>
          <span className="breadcrumb-current">Customer Details</span>
        </div>

        {/* buttons */}
        <div className="top-bar">
          {/* tap buttons */}
          <div className="top-buttons">
            <button className="tab-btn active">Personal Details</button>
            <button className="tab-btn" onClick={goToWallet}>Wallet Details</button>
            {/* <button className="tab-btn" onClick={goToWalletSummary}>Customer Wallet Summary</button> */}
            <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
          </div>
        </div>

        

        {/* Basic Details */}
        <div className="section">
          {/* edit button */}
        <div className="edit-btn-wrap">
          <button className="edit-btn" onClick={goToEdit}>Edit</button>
        </div>
          <h3><FaRegUserCircle /> Basic Details</h3>
          <div className="section-content">
            {(customer.photo_url || customer.profile_picture || customer.profile_image || customer.profile_photo || customer.avatar) && (
              <div style={{ marginBottom: "15px" }}>
                <img 
                  src={customer.photo_url || customer.profile_picture || customer.profile_image || customer.profile_photo || customer.avatar} 
                  alt="Profile" 
                  style={{ width: "100px", height: "100px", borderRadius: "50%", objectFit: "cover", border: "2px solid #eaeaea" }} 
                />
              </div>
            )}
            <p><strong>Customer ID:</strong> {customer.Customer_id || customer.id || 'N/A'}</p>
            <p><strong>First name:</strong> {firstName}</p>
            <p><strong>Surname:</strong> {surname}</p>
            <p><strong>Email:</strong> {email}</p>
            <p><strong>Mobile:</strong> {mobile}</p>
            {customer.additional_information && (
              <p><strong>Additional Information:</strong> {customer.additional_information}</p>
            )}
          </div>
        </div>

        {/* Address */}
        <div className="section">
          <h3><MdOutlineLocationOn /> Address</h3>
          <div className="section-content">
            <p><strong>Address line 1:</strong> {addressLine1}</p>
            <p><strong>Address line 2:</strong> {addressLine2}</p>
            <p><strong>Address line 3:</strong> {addressLine3}</p>
            <p><strong>City:</strong> {city}</p>
            <p><strong>Region:</strong> {region}</p>
            <p><strong>Postcode:</strong> {postcode}</p>
            <p><strong>Country:</strong> {country}</p>
            
          </div>
        </div>

        {/* Status */}
        <div className="section">
          <h3><MdUpdate /> Status</h3>
          <div className="section-content">
            <p><strong>Email Status:</strong> <span className={`status-badge ${status.toLowerCase()}`}>{status}</span></p>
            <p><strong>Notes:</strong> {notes}</p>
            {customer.email_verified_at && (
              <p><strong>Email Verified:</strong> {new Date(customer.email_verified_at).toLocaleDateString()}</p>
            )}
          </div>
        </div>

        {/* Referred By */}
        <div className="section">
          <h3><MdOutlineAssignmentInd /> Referred By</h3>
          <div className="section-content">
            <p><strong>Referrer ID:</strong> {customer.referrer_id || 'N/A'}</p>
            <p><strong>Referrer:</strong> {customer.referrer_name || 'N/A'}</p>
            
          <p><strong>Referrer Agent Type:</strong> {
            customer.referrer_agent_type === 'mini' 
              ? 'Mini Ads Agent' 
              : customer.referrer_agent_type === 'senior' 
              ? 'Senior Ads Agent' 
              : customer.referrer_agent_type || 'N/A'
          }</p>
          <p><strong>Referrer Country:</strong> {customer.referrer_country || 'N/A'}</p>
          <p><strong>Referrer Region:</strong> {customer.referrer_region || 'N/A'}</p>
          <p><strong>Referrer Email:</strong> {customer.referrer_email || 'N/A'}</p>
          <p><strong>Referrer Phone:</strong> {customer.referrer_phone || 'N/A'}</p>
          </div>
      </div>
      </div>
    </div>
  );
}

export default CustomerDetails;
